// extracted by mini-css-extract-plugin
export default {"button":"Flpo_xXmOJkXdCIkljVb","icon":"XYLh0uNhalUGfcD1Qkmc"};